webpackJsonp([101962659229780],{

/***/ 485:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _check = __webpack_require__(146);
	
	var _check2 = _interopRequireDefault(_check);
	
	__webpack_require__(485);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'pretty p-svg p-curve p-plain' },
	    _react2.default.createElement('input', { type: 'checkbox' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'state' },
	      _react2.default.createElement(_check2.default, { className: 'svg svg-icon' }),
	      _react2.default.createElement('label', null)
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 488:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Content = __webpack_require__(6);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Checkbox = __webpack_require__(460);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	__webpack_require__(488);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$headings = _ref.headings,
	      headings = _ref$headings === undefined ? [] : _ref$headings,
	      _ref$items = _ref.items,
	      items = _ref$items === undefined ? [] : _ref$items,
	      checklist = _ref.checklist;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Table hasShadow hasBorder' },
	    headings && !!headings.length && _react2.default.createElement(
	      'div',
	      { className: 'Table--Headings Table--Row' },
	      headings.map(function (heading, index) {
	        return _react2.default.createElement(
	          'div',
	          {
	            className: 'Table--Headings--Item Table--Cell',
	            key: heading + index
	          },
	          heading
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'Table--Body' },
	      items && items.map(function () {
	        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	        var index = arguments[1];
	        return _react2.default.createElement(
	          'div',
	          { className: 'Table--Row', key: 'item' + index },
	          _react2.default.createElement(
	            'div',
	            { className: 'Table--Cell' },
	            _react2.default.createElement(_Content2.default, { src: item['cell1'] }),
	            ' ',
	            checklist && _react2.default.createElement(_Checkbox2.default, null)
	          ),
	          item['cell2'] && _react2.default.createElement(
	            'div',
	            { className: 'Table--Cell' },
	            item['cell2']
	          )
	        );
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.HealthInfoPageTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageHeader = __webpack_require__(15);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(6);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Accordion = __webpack_require__(76);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _Table = __webpack_require__(446);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _ExceedBanner = __webpack_require__(28);
	
	var _ExceedBanner2 = _interopRequireDefault(_ExceedBanner);
	
	__webpack_require__(701);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Export Template for use in CMS preview
	var HealthInfoPageTemplate = exports.HealthInfoPageTemplate = function HealthInfoPageTemplate(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      featuredImage = _ref.featuredImage,
	      downloadBanner = _ref.downloadBanner,
	      popoutBanner = _ref.popoutBanner,
	      accordion = _ref.accordion,
	      body = _ref.body,
	      lowerSection = _ref.lowerSection,
	      table = _ref.table,
	      footerSettings = _ref.footerSettings,
	      meta = _ref.meta;
	  return _react2.default.createElement(
	    'main',
	    { className: 'HealthInfoPage background-dots' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { defaultTitle: meta && meta.title || title + ' | Great Start ELC' },
	      meta && _react2.default.createElement('meta', { name: 'description', content: meta.description }),
	      meta && _react2.default.createElement('link', { rel: 'canonical', href: meta.canonical })
	    ),
	    _react2.default.createElement(_PageHeader2.default, { title: title, subtitle: subtitle }),
	    _react2.default.createElement(
	      'section',
	      { className: 'section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container content' },
	        _react2.default.createElement(_Content2.default, { source: body })
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container content' },
	        _react2.default.createElement(_Table2.default, {
	          headings: table.headings.map(function (item) {
	            return item.heading;
	          }),
	          items: table.items
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section background-clouds' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container content' },
	        _react2.default.createElement(_Content2.default, { source: lowerSection })
	      ),
	      accordion && _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'div',
	          { className: 'container content' },
	          _react2.default.createElement(_Accordion2.default, { items: accordion })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section thin' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_ExceedBanner2.default, { footerSettings: footerSettings })
	      )
	    )
	  );
	};
	
	var HealthInfoPage = function HealthInfoPage(_ref2) {
	  var data = _ref2.data;
	  var page = data.markdownRemark,
	      footerSettings = data.footerSettings;
	
	
	  return _react2.default.createElement(HealthInfoPageTemplate, _extends({}, page, page.frontmatter, { body: page.html, footerSettings: footerSettings }));
	};
	
	exports.default = HealthInfoPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-health-info-page-js-f11bcc72b5afb5bad68c.js